import React from 'react';
import { WrenchIcon, PiggyBankIcon, CalendarClockIcon, ShieldCheckIcon, EyeOffIcon, FileTextIcon } from 'lucide-react';
const benefits = [{
  icon: WrenchIcon,
  title: 'Sell As-Is',
  description: "Don't spend a dime on repairs. We buy houses in any condition, even if they need major work."
}, {
  icon: PiggyBankIcon,
  title: 'No Agent Commissions',
  description: 'Keep more money in your pocket. You pay zero real estate agent fees or hidden costs.'
}, {
  icon: EyeOffIcon,
  title: 'Avoid Showings',
  description: 'No open houses, no strangers walking through your home, and no keeping it perfectly clean.'
}, {
  icon: CalendarClockIcon,
  title: 'Close in Days',
  description: 'Skip the months of waiting. We can close in as little as 7 days, or on your exact schedule.'
}, {
  icon: FileTextIcon,
  title: 'We Handle Everything',
  description: 'From the paperwork to the title company, our team manages the entire process for you.'
}, {
  icon: ShieldCheckIcon,
  title: 'Guaranteed Offer',
  description: 'Unlike traditional buyers whose financing can fall through, our cash offers are guaranteed.'
}];
export function BenefitsSection() {
  return <section className="py-20 md:py-28 px-6 md:px-12 lg:px-16" data-id="element-4">
      <div className="max-w-7xl mx-auto" data-id="element-5">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-6">
          {/* Left: Image */}
          <div className="order-2 lg:order-1" data-id="element-7">
            <div className="relative rounded-2xl overflow-hidden aspect-[3/4] shadow-xl" data-id="element-8">
              <img src="https://cdn.magicpatterns.com/uploads/iQbHi3sBWSq3ooTiSQX3H4/7AA8D80C-2208-4B23-83B7-CD7C582B47C7.png" alt="Florida single family home with palm trees" className="w-full h-full object-cover" data-id="element-9" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" data-id="element-10" />
            </div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2" data-id="element-11">
            <div className="mb-8" data-id="element-12">
              <span className="text-xs font-bold text-[#E8913A] uppercase tracking-widest mb-3 block" data-id="element-13">
                The Bevo Coastal Advantage
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B2A4A] mb-6 tracking-tight" data-id="element-14">
                Why Homeowners Choose Us
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-15">
                We provide a faster, easier, and more transparent way to sell
                your home compared to the traditional market.
              </p>
            </div>

            <div className="flex flex-col" data-id="element-16">
              {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return <div key={benefit.title} className={`py-4 ${index !== benefits.length - 1 ? 'border-b border-slate-100' : ''}`} data-id="element-17">
                    <div className="flex items-start gap-4" data-id="element-18">
                      <Icon className="w-6 h-6 text-[#E8913A] shrink-0 mt-0.5" data-id="element-19" />
                      <div data-id="element-20">
                        <h3 className="text-xl font-bold text-[#1B2A4A] mb-1.5" data-id="element-21">
                          {benefit.title}
                        </h3>
                        <p className="text-slate-600 leading-relaxed" data-id="element-22">
                          {benefit.description}
                        </p>
                      </div>
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}